import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

export type QueryParams = {
  [key: string]: string
}

export type TrackingSteps = {
  adi: string
  sessionId: number
  route: string
  academy: string
  product: string
  funnel: string
}

export type TrackingFields = {
  queryParams: QueryParams
  currentStep: TrackingSteps
  // aid: string
}

export type TrackingStore = TrackingFields & {
  setQueryParams(qParams: QueryParams): void
  setCurrentStep(currentStep: TrackingSteps): void
  deleteKeyFromParam(key: string): void
  reset(): void
}

const initialState = {
  queryParams: {},
  currentStep: null,
}

export const useTrackingStore = create<TrackingStore>()(
  persist(
    (set) => ({
      ...initialState,
      setQueryParams: (qParams: QueryParams) => {
        set((state) => {
          return {
            queryParams: { ...state.queryParams, ...qParams },
          }
        })
      },
      setCurrentStep: (currentStep: TrackingSteps) => {
        set((state) => {
          return {
            currentStep: currentStep,
          }
        })
      },
      deleteKeyFromParam: (key: string) => {
        set((state) => {
          const newParams = { ...state.queryParams }
          delete newParams[key]
          return {
            queryParams: newParams,
          }
        })
      },
      reset: () => set(initialState),
    }),
    {
      name: 'tracking-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
)
